import React, { useRef } from 'react';
import Select, { components } from 'react-select';

import ToolsDropdownIndicator from './ToolsDropdownIndicator';
import { OPTIONS_WITH_SELECTED, REACT_SELECT_TOOL_BAR_STYLE } from './utils';

const ToolWithOptions = ({ content, actions, ...selectOptions }) => {
  const selectRef = useRef(null);

  const ContentDisplay = ({ children }) => (
    <div>
      {content}
      <div style={{ display: 'hidden', position: 'fixed', top: '-10000px' }}>{children}</div>
    </div>
  );

  const ActionDisplay = ({ data, ...props }) => (
    <components.Option {...props}>{data.content}</components.Option>
  );

  return (
    <Select
      ref={selectRef}
      classNamePrefix="tool-with-options__select"
      options={actions}
      components={{
        DropdownIndicator: ToolsDropdownIndicator,
        IndicatorSeparator: null,
        ValueContainer: ContentDisplay,
        Option: ActionDisplay,
      }}
      styles={OPTIONS_WITH_SELECTED}
      onChange={({ action }) => action()}
      filterOption={() => true}
      isClearable={false}
      openMenuOnClick={false}
      noOptionsMessage={() => null}
      {...selectOptions}
    />
  );
};

export default ToolWithOptions;
